import type { ExtendedIconButtonProps } from '@src/shared/ui/Button/IconButton';
import { ArrowLeftIcon } from '@src/shared/ui/icons';
import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import NavIconButton from './NavIconButton';

const PrevIconButton = forwardRef<HTMLButtonElement, ExtendedIconButtonProps>(
  (props, ref) => {
    const { t } = useTranslation();

    return (
      <NavIconButton
        ref={ref}
        {...props}
        tooltipTitle={props.tooltipTitle ?? t('common.previous', 'Previous')}
      >
        <ArrowLeftIcon />
      </NavIconButton>
    );
  },
);

export default PrevIconButton;
